import { render, staticRenderFns } from "./TvTariffs.vue?vue&type=template&id=b5825602&"
import script from "./TvTariffs.vue?vue&type=script&lang=js&"
export * from "./TvTariffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports